import Store from '@get-bridge/learn-legacy-shared/dist/core/Store'
import createTask from '../data_requests/createTask'
import deleteTask from '../data_requests/deleteTask'
import getTasks from '../data_requests/getTasks'
import updateTask from '../data_requests/updateTask'
import TaskPayload from '../schemas/TaskPayload'
import { FetchStatus } from '../../constants'

export default Store({
  schema: TaskPayload,

  initialize() {
    this.createStatus = FetchStatus.UNSENT
    this.fetchStatus = FetchStatus.UNSENT
    this.updateStatus = {}
    this.deleteStatus = {}
  },

  storeOptions: {
    defaultCacheOptions: {
      idGenerator(task) {
        return task.uid;
      }
    }
  },

  getAll() {
    return this.cache.getCollection({})
  },

  fetchAll() {
    this.fetchStatus = FetchStatus.LOADING
    return getTasks().then((tasks) => {
      this.fetchStatus = FetchStatus.DONE
      this.cache.setCollection({}, tasks)
      return tasks
    }, (e) => {
      this.fetchStatus = FetchStatus.ERROR
      this.emitChange()
      throw e
    })
  },

  create(task) {
    this.createStatus = FetchStatus.LOADING

    return createTask(task).then((savedTask) => {
      this.createStatus = FetchStatus.DONE
      this.cache.addToCollection({}, [savedTask])
      return savedTask
    }, () => {
      this.createStatus = FetchStatus.ERROR
      this.emitChange()
    })
  },

  update(task) {
    return this.cache.transaction(() => {
      this.updateStatus[task.uid] = FetchStatus.LOADING
      this.cache.add(task)

      return updateTask(task).then(() => {
        this.updateStatus[task.uid] = FetchStatus.DONE
        this.emitChange()
      }, (e) => {
        this.updateStatus[task.uid] = FetchStatus.ERROR
        this.emitChange()
        throw e
      })
    })
  },

  delete(task) {
    this.deleteStatus[task.uid] = FetchStatus.LOADING

    return deleteTask(task).then(() => {
      this.deleteStatus[task.uid] = FetchStatus.DONE
      this.cache.remove(task.uid)
    }, (e) => {
      this.deleteStatus[task.uid] = FetchStatus.ERROR
      this.emitChange()
      throw e
    })
  }
})



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/tasks/stores/TaskStore.js